import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  onRefresh: () => void;
}

const UpdateAvailableBanner: React.FC<Props> = ({ onRefresh }) => {
  const { t } = useTranslation('common');
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;
  return (
    <div
      role="alert"
      aria-live="polite"
      className="fixed top-[10vh] left-1/2 -translate-x-1/2 z-50 flex items-center gap-3 rounded-lg bg-fp-card border border-yellow-500/40 px-4 py-3 shadow-xl text-sm text-gray-200 max-w-sm"
    >
      <span className="text-yellow-400 font-medium">{t('updateBanner.title')}</span>
      <span className="text-gray-400">{t('updateBanner.description')}</span>
      <button
        onClick={onRefresh}
        className="ml-auto shrink-0 rounded bg-yellow-500 px-3 py-1 text-xs font-semibold text-gray-900 hover:bg-yellow-400 transition-colors"
      >
        {t('updateBanner.reload')}
      </button>
      <button
        onClick={() => setDismissed(true)}
        aria-label={t('updateBanner.dismiss')}
        className="shrink-0 text-gray-500 hover:text-gray-300 transition-colors"
      >
        ✕
      </button>
    </div>
  );
};

export default UpdateAvailableBanner;
